import CtaBoxColumns from './ctaBoxColumns';

export default CtaBoxColumns;
